module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result18-f24a837c2f008e9b43f9ca5e0d3f45d3.png";